<template>
  <div class="mentora365Component">
    <div class="container-fluid padding-bottom-2Perc">
      <div class="row margin-top-3Perc">
        <div class="col-md-6 col-lg-6">
          <div class="row vertical-align">
            <div class="col-md-4 col-lg-4 text-align-right Padding-right-0px">
              <b>Group</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
                  <select class="form-control" v-model="getSelectedGroupObj">
                    <option value=-1 disabled>Select</option>
                    <option v-for="grpObj in getGroupList" v-bind:key="grpObj.GroupId" v-bind:value="grpObj">{{ grpObj.GroupName }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- course -->
          <div class="row vertical-align margin-top-6Perc">
            <div class="col-md-4 col-lg-4 text-align-right Padding-right-0px">
              <b>Course</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px text-align-left">
                  <b>{{getCourseTitle}}</b>
                </div>
              </div>
            </div>
          </div>
          <!--end of course -->
          <!-- notification title -->
          <div class="row vertical-align margin-top-6Perc">
            <div class="col-md-4 col-lg-2 col-lg-offset-2 text-align-right Padding-right-0px"><b>Notification Title</b></div> 
            <div class="col-md-8 col-lg-8">
              <div class="form-group margin-bottom-0px">
                <input type="text" class="form-control" v-model="notificationTitle">
              </div>  
            </div>
          </div>
          <!-- End of notification title -->
          <div class="row margin-top-6Perc margin-bottom-2Perc">
            <div class="font-size-15px create-lesson-input-text-style col-md-2 col-md-offset-2 col-lg-2 col-lg-offset-2 text-align-right Padding-right-0px">
              <b>Notification Description</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <textarea class="form-control" rows="5" v-model="notificationDesc"></textarea>
              </div>
            </div>
          </div>
          <div class="row margin-top-6Perc margin-bottom-2Perc">
            <div class="font-size-15px create-lesson-input-text-style col-md-2 col-md-offset-2 col-lg-2 col-lg-offset-2 text-align-right Padding-right-0px">
              <b>Schedule</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group" style="text-align: left">
                <input type="checkbox" v-model="schedule">
              </div>
            </div>
          </div>
          <div class="row margin-top-6Perc margin-bottom-2Perc" v-if="schedule">
            <div class="font-size-15px create-lesson-input-text-style col-md-2 col-md-offset-2 col-lg-2 col-lg-offset-2 text-align-right Padding-right-0px">
              <b>ScheduleTS</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <date-picker v-model="scheduleTS" :config="config"></date-picker>
                <div class="current_time">
                  <b>Current EST -</b> {{currentEST}}
                  <button class="btn btn-default btnRefresh" @click="refreshCurrentEST()">
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> 
        <div class="col-md-6 col-lg-6">
          <!-- Group Course -->
          <div class="row vertical-align">
            <div class="col-md-2 col-lg-2 text-align-right Padding-right-0px">
              <b>Group Course</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
                  <select class="form-control" v-model="selectedCourseMomentObj">
                    <option value='-1' disabled>Select</option>
                    <option v-for="momentCourseObj in momentCourseList" v-bind:key="momentCourseObj.GroupCourseMasterId" v-bind:value="momentCourseObj">{{ momentCourseObj.GroupName }} :: {{momentCourseObj.CourseTitle}} {{momentCourseObj.CourseSubTitle !== null && momentCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + momentCourseObj.CourseSubTitle + ']': ''}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-lg-2"></div>
          </div>
          <div class="row vertical-align" v-if="selectedCourseMomentObj !== -1">
            <div class="col-md-2 col-lg-2 text-align-right Padding-right-0px">
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px font-size-12Px">
                  <b>Release Date:</b> {{getExpiryCourseDate}} <b>Expiry Days:</b> {{getExpiryCourseDays}}
                </div>
              </div>
            </div>
            <div class="col-md-2 col-lg-2"></div>
          </div>
          <!-- End of group course -->
          <!-- Cohort -->
          <div class="row vertical-align margin-top-3Point5Perc">
            <div class="col-md-2 col-lg-2 text-align-right Padding-right-0px">
              <b>Cohort</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
                  <select class="form-control" v-model="currSelectedCohortObj">
                    <option value='-1' disabled>Select</option>
                    <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-lg-2"></div>
          </div>


          <!-- End Of Cohort -->
          <div class="row margin-top-4Point8Perc vertical-align">
            <div class="col-md-2 col-lg-2 text-align-right Padding-right-0px margin-top-15px"> 
               <b>Upload User(s) via CSV</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 Padding-left-0px Padding-right-0px">
                  <div class="text-align-left" >
                    <input type="checkbox" v-model="uploadUserListViaCSVValue">
                  </div>
                </div>
              </div>
            </div> 
            <div class="col-md-2 col-lg-2"></div>       
          </div>
          
          <div class="row margin-top-4Point8Perc">
            <div class="col-md-2 col-lg-2 text-align-right Padding-right-0px margin-top-15px"> 
              <b>Users</b>
            </div>
            <div class="col-md-8 col-lg-8">
              <div class="border-1px padding-15px usersList" v-if="!uploadUserListViaCSVValue">
                <div class="text-align-left margin-bottom-5px" v-if="getUserListValue.length > 0">
                  <u>Total Selected {{selectedUserIdList.length > 1 ? 'Users' : 'User' }}:</u> <b>{{selectedUserIdList.length}}</b>
                </div>
                <div class="text-align-left" v-if="getUserListValue.length > 0">
                  <input type="checkbox" v-model="isSelectedAllUserValue"> Select All
                </div>
                <div class="text-align-left" v-for="userObj in getUserListValue" :key="userObj.UserId">
                    <input type="checkbox" :value="userObj.UserId" v-model="selectedUserIdList"> {{userObj.FirstName + ' ' + userObj.LastName}}
                </div>
                <div v-if="getUserListValue.length === 0" class="text-align-left">
                  No User(s)
                </div>
              </div>
              <div class="border-1px padding-15px usersList" v-else>
                <div><input type="file" accept=".csv" id="uploadcsvfile"></div>
                <!-- <span style="float:left; margin-top: 5px">|</span> -->
                <div class="cursor-pointer text-decoration-underline text-color-blue" style="margin-top: 15px;" @click="downloadUserCSVTemplate">Download Template</div>
              </div>
            </div> 
            <div class="col-md-2 col-lg-2"></div>       
          </div>
        </div>  
      </div>
      <div class="row margin-bottom-2Perc margin-top-1Perc">  
        <div class="col-md-2 col-md-offset-5 col-lg-2 col-lg-offset-5">
          <button class="btn btn-default button-orange black-font-color" @click="askUserConfirmation($event)">Send Notification</button>
        </div>  
        <div class="col-md-5 col-lg-5">
        </div>
      </div>      
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
     <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div> 
    <loader></loader>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="sendNotification"></confirmation-alert>
  </div>
</template>

<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import datePicker from 'vue-bootstrap-datetimepicker'
import { groupService } from '@/server-util/group-service'
import { groupCourseService } from '@/server-util/group-course-service'
import { cohortService } from '@/server-util/cohort-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import Loader from '@/components/dashboard/Loader'
import { notificationService } from '@/server-util/notification-service'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import isEmpty from 'lodash/isEmpty'
import filter from 'lodash/filter'
import forEach from 'lodash/forEach'
import csvHelper from '@/utils/csv-helper'

export default {
  created: function () {
    this.setDefaultValues()
    this.getGroups()
  },
  data: function () {
    return {
      showConfirmationBox: false,
      prefixString: 'Are you sure you want to delete ',
      postString: '',
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      groupObj: -1,
      momentCourseList: [],
      selectedCourseMomentObj: -1,
      userObjList: [],
      groupList: [],
      m365LessonList: [],
      selectedContentOfDayObj: -1,
      selectedUserIdList: [],
      associatedCohortList: [],
      selectedCohortObj: -1,
      showNoUserTxtInUserBox: true,
      notificationDesc: '',
      notificationTitle: '',
      isSelectedAllUser: false,
      isNotifSentSuccessfully: false,
      schedule: false,
      localMOTDList: [],
      scheduleTS: new Date(),
      currentEST: new Date(),
      config: {
        format: 'MM/DD/YYYY h:mm:ss A',
        defaultDate: new Date(),
        useCurrent: true,
        sideBySide: true
      },
      uploadUserListViaCSV: false
    }
  },
  components: {
    'alert-box': AlertBox,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader,
    'date-picker': datePicker
  },
  methods: {
    checkCSVFileExtesion: function (fileName) {
      var exts = ['.csv', '.CSV']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    downloadUserCSVTemplate: function () {
      // AK: Used to download CSV file
      var columnAlias = ['Email']
      var columnRespKey = ['']
      return csvHelper.export(null, columnRespKey, columnAlias, 'NotificationUserListTemplate')
    },
    formatAndShowESTDateAndTime: function (date) {
      if (date !== undefined && date !== null && date !== 'null' && date !== '') {
        var dateToPass = date
        if (dateToPass.indexOf('Z') === -1) {
          dateToPass += 'Z'
        }
        return dmAdminUtils.covertUtcToEst(dateToPass)
      } else {
        return 'NA'
      }
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedCourseMomentObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedCourseMomentObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedCourseMomentObj.CourseSubTitle === null ? '' : ' [' + this.selectedCourseMomentObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedCourseMomentObj.GroupName + ' :: ' + this.selectedCourseMomentObj.CourseTitle + subTitleName + '\'.'
                this.selectedCohortObj = -1
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getMomentCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== ''
      ) {
        _this.$store.state.isLoading = true
        groupCourseService
          .getAvailableM365(
            storeObj.state.access_token,
            this.getSelectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              _this.momentCourseList = responseObj.data
              if (_this.momentCourseList.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No courses were found in \'' + this.getSelectedGroupObj.GroupName + '\' group.'
              }
              _this.$store.state.isLoading = false
              // console.log('_this.momentCourseList: ' + JSON.stringify(_this.momentCourseList))
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined MOMENT COURSE LISTING OPERATION'
        )
      }
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    setDefaultValues: function () {
      this.scheduleTS = dmAdminUtils.getCurrentEst(0, 2, 0)
      this.currentEST = dmAdminUtils.getCurrentEst()
    },
    refreshCurrentEST: function () {
      this.currentEST = dmAdminUtils.getCurrentEst()
    },
    sendNotification (value) {
      if (value) {
        this.showConfirmationBox = false
        this.sendNotificationToUser()
      }
    },
    sendNotificationToUser: function () {
      var storeObj = this.$store
      this.$store.state.isLoading = true
      const formData = new FormData()
      var obj = {
        'GroupId': this.selectedCourseMomentObj.GroupId,
        'UserIds': null,
        'NotifTitle': this.notificationTitle,
        'NotifText': this.notificationDesc,
        'CohortId': this.selectedCohortObj.CohortId,
        'GroupCourseMasterId': this.selectedCourseMomentObj.GroupCourseMasterId,
        'ScheduleTS': this.schedule ? this.scheduleTS : null
      }
      if (!this.uploadUserListViaCSVValue) {
        obj.UserIds = this.selectedUserIdList.join(',')
        formData.append('UserCSV', null)
      } else {
        var fileUrl = document.getElementById('uploadcsvfile').files[0]
        formData.append('UserCSV', fileUrl)
      }
      formData.append('Object', JSON.stringify(obj))
      notificationService.sendM365PushNotification(storeObj.state.access_token, formData)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Total Users: <b>' + responseObj.data.TotalUsers + '</b><br/>Total Sent: <b>' + responseObj.data.TotalNotifSent + '</b><br/> Total Queued: <b>' + responseObj.data.TotalNotifQueued + '</b><br/> Failed Count: <b>' + responseObj.data.FailedUsersCount + '</b>'
              if (responseObj.data.FailedUsersListWithMsg.length > 0) {
                this.errorMsg += '<br/><div style="text-align: left !important;"><b><u>Error Summary:</u></b></div><br/>'
                forEach(responseObj.data.FailedUsersListWithMsg, (response, index) => {
                  this.errorMsg += '<div style="text-align: left !important;">' + (index + 1) + '. ' + response + '</div>'
                })
              }
              this.isNotifSentSuccessfully = true
            } else {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
    },
    askUserConfirmation: function (event) {
      if (this.checkRequiredFiledsBeforeSubmit()) {
        this.showConfirmationBox = true
        this.prefixString = 'Are you sure you want to'
        this.postString = !this.uploadUserListViaCSVValue ? ' send notification to selected user(s)?' : ' send notification for uploaded csv user(s)?'
      } else {
        console.log('Validation fail')
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      // AK: If user recieved success msg on sent email then only reset values (DM-2343)
      if (this.isNotifSentSuccessfully) {
        this.isNotifSentSuccessfully = false
        this.resetAllFields()
      }
    },
    resetAllFields: function () {
      this.groupObj = -1
      this.selectedCourseMomentObj = -1
      this.userObjList = []
      this.selectedUserIdList = []
      this.momentCourseList = []
      this.associatedCohortList = []
      this.showNoUserTxtInUserBox = true
      this.notificationDesc = ''
      this.notificationTitle = ''
      this.isSelectedAllUser = false
      this.isNotifSentSuccessfully = false
      this.schedule = false
      this.scheduleTS = dmAdminUtils.getCurrentEst(0, 2, 0)
    },
    getUsers: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedCourseMomentObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getM365ParticipantList(
            storeObj.state.access_token,
            this.selectedCourseMomentObj.GroupId,
            this.selectedCourseMomentObj.GroupCourseMasterId,
            this.selectedCohortObj.CohortId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving User list response
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                this.showNoUserTxtInUserBox = true
                this.errorMsg = 'No user(s) found in \'' + this.selectedCohortObj.CohortName + '\' cohort.'
              } else {
                this.showNoUserTxtInUserBox = false
              }
              this.userObjList = filter(responseObj.data, (obj) => {
                return obj.AccountType !== constants.UserAccountType.Coach
              })
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated User(s) OPERATION'
        )
      }
    },
    checkRequiredFiledsBeforeSubmit: function () {
      if (this.getSelectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
        return false
      } else if (this.notificationTitle.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Notification title can\'t be empty.'
        return false
      } else if (this.notificationTitle.trim().length > 50) {
        this.showAlertDialog = true
        this.errorMsg = 'Notification title can\'t be more than 50 characters.'
        return false
      } else if (this.notificationDesc.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Notification description can\'t be empty.'
        return false
      } else if (this.notificationDesc.trim().length > 200) {
        this.showAlertDialog = true
        this.errorMsg = 'Notification description can\'t be more than 200 characters.'
        return false
      } else if (this.selectedCourseMomentObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group course.'
        return false
      } else if (this.selectedCohortObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a cohort.'
        return false
      } else if (!this.uploadUserListViaCSVValue && this.selectedUserIdList.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select at least one participant to send notification.'
        return false
      } else if (this.uploadUserListViaCSVValue) {
        var fileUrl = document.getElementById('uploadcsvfile').files[0]
        if (fileUrl !== undefined) {
          if (!this.checkCSVFileExtesion(document.getElementById('uploadcsvfile').value)) {
            this.showAlertDialog = true
            this.errorMsg = 'Invalid file format detected.'
            return false
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a .csv file.'
          return false
        }
      }
      return true
    },
    isAllUserSelected: function () {
      this.selectedUserIdList = []
      if (this.isSelectedAllUser) {
        for (var i = 0; i < this.userObjList.length; i++) {
          this.selectedUserIdList.push(this.userObjList[i].UserId)
        }
      }
    },
    formatAndShowDate: function (date) {
      if (date !== undefined) {
        var dateToPass = date
        if (dateToPass.indexOf('Z') === -1) {
          dateToPass += 'Z'
        }
        return '(' + dmAdminUtils.covertUtcToEstWithoutTime(dateToPass) + ')'
      }
    }
  },
  computed: {
    uploadUserListViaCSVValue: {
      get: function () {
        return this.uploadUserListViaCSV
      },
      set: function (newValue) {
        this.uploadUserListViaCSV = newValue
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    currSelectedCohortObj: {
      get: function () {
        return this.selectedCohortObj
      },
      set: function (newValue) {
        this.selectedCohortObj = newValue
        this.isSelectedAllUser = false
        this.userObjList = []
        this.selectedUserIdList = []
        this.getUsers()
      }
    },
    getCourseTitle: {
      get: function () {
        if (this.selectedCourseMomentObj !== -1) {
          var strToShow = ''
          if (!isEmpty(this.selectedCourseMomentObj.DisplayTitle)) {
            strToShow = this.selectedCourseMomentObj.DisplayTitle
            if (!isEmpty(this.selectedCourseMomentObj.DisplaySubTitle)) {
              strToShow += ' [' + this.selectedCourseMomentObj.DisplaySubTitle + ']'
            }
          } else {
            strToShow = this.selectedCourseMomentObj.CourseTitle
            if (!isEmpty(this.selectedCourseMomentObj.CourseSubTitle)) {
              strToShow += ' [' + this.selectedCourseMomentObj.CourseSubTitle + ']'
            }
          }
          return strToShow
        } else {
          return 'Select a group above'
        }
      }
    },
    getSelectedGroupObj: {
      // Used to hold only group dropdown values
      get: function () {
        return this.groupObj
      },
      set: function (newValue) {
        this.groupObj = newValue
        this.selectedCourseMomentObj = -1
        this.selectedCohortObj = -1
        this.selectedCourseMomentObj = -1
        this.userObjList = []
        this.isSelectedAllUnEnrolledUser = false
        this.isSelectedAllUser = false
        this.getMomentCourses()
      }
    },
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    getUserListValue: {
      get: function () {
        return this.userObjList
      }
    },
    isSelectedAllUserValue: {
      get: function () {
        return this.isSelectedAllUser
      },
      set: function (newValue) {
        this.isSelectedAllUser = newValue
        this.isAllUserSelected()
      }
    },
    getExpiryCourseDate: {
      get: function () {
        return this.formatAndShowESTDateAndTime(this.selectedCourseMomentObj.ReleaseTS)
      }
    },
    getExpiryCourseDays: {
      get: function () {
        return this.selectedCourseMomentObj.ExpiryDays
      }
    }
  },
  watch: {
    selectedUserIdList: function (newValue, oldValue) {
      if (this.selectedUserIdList.length === this.userObjList.length && this.userObjList.length > 0) {
        this.isSelectedAllUser = true
      } else {
        this.isSelectedAllUser = false
      }
    },
    selectedCourseMomentObj: function (newValue, oldValue) {
      // AK: Reset Selected Cohort Obj to -1 again
      this.selectedCohortObj = -1
      this.isSelectedAllUnEnrolledUser = false
      this.isSelectedAllUser = false
      this.userObjList = []
      if (newValue !== -1) {
        this.getAssociatedCohortList()
      }
    }
  },
  name: 'mentora365Component'
}
</script>

<style scoped>
.margin-bottom-10px {
  margin-bottom: 10px;
}
.margin-bottom-5px {
  margin-bottom: 5px;
}
.opacity {
  opacity: 0.75;
}
.text-decoration-underline {
  text-decoration: underline;
}
.text-color-blue {
  color: blue;
}
.mentora365Component {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-green {
  border: 1px solid green;
}
.width-70Perc {
  width: 70%;
}
.width-88Perc {
  width: 88%;
}
.width-90Perc {
  width: 90%;
}
.width-96Perc {
  width: 96%;
}
.text-align-left {
  text-align: left !important;
}
.text-align-right {
  text-align: right !important;
}
.Padding-left-0px {
  padding-left: 0px !important;
}
.Padding-right-0px {
  padding-right: 0px !important;
}
.font-size-18px {
  font-size: 18px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.background-gray {
  background-color: #ddd;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.margin-bottom-1Perc {
  margin-bottom: 2% !important;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-6Perc {
  margin-top: 6%;
}
.margin-top-4Point8Perc {
  margin-top: 4.8%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.margin-top-1perc {
  margin-top: 1%;
}
.right-border-color {
  /*border-right: 1px solid #43495e;*/
}
.vertical-align {
  display: flex;
  align-items: center;
}
.width-1Perc {
  width: 1% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.font-weight-bold {
  font-weight: bold;
}
.font-size-15px {
  font-size: 15px;
}
.margin-0-auto{
  margin: 0 auto !important;
}
.border-color-yellow{
  border:1px solid yellow;
}
.demo-margin-left-1Perc{
  margin-left:1% !important;
}
.border-grey{
  border:1px solid grey;
}
.padding-left-1Perc{
  padding-left:1%;
}
.padding-left-12Perc{
  padding-left:12%;
}
.padding-bottom-2Perc{
  padding-bottom:2% !important;
}
.padding-bottom-5Perc{
  padding-bottom:5% !important;
}
.margin-bottom-10Perc{
  margin-bottom: 10% !important;
}
.padding-15px{
  padding:15px;
}
.border-1px{
  border: 1px solid #ccc;
}
.cursor-pointer{
    cursor: pointer;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.margin-top-0Point5Perc{
  margin-top: 0.5%;
}
.margin-top-1Perc{
  margin-top: 1%;
}
.margin-top-10px{
  margin-top: 10px;
}
.padding-right-0Perc{
  padding-right:0%;
}
.vertical-align {
  display: flex !important;
  align-items: center !important;
}
.align-center{
  align: center !important;
}
.button-orange{
    background-color: #f39c12 !important;
    border: 1px solid #f39c12 !important;
}
.text-align-left{
  text-align: left !important;
}
.red-border{
  border: 1px solid red;
}
.vertical-align {
  display: flex !important; 
  align-items: center !important;
}
.font-size-14Px{
  font-size: 14px !important;
}
.margin-top-5px{
  margin-top: 5px;
}
.border-red{
  border: 1px solid red;
}
.button-orange {
  background-color: #f39c12!important;
  border: 1px solid #f39c12!important;
}
.margin-top-15px {
  margin-top:15px;
}
.current_time {
  margin-top: 10px;
  text-align: left;
}
.btnRefresh {
  margin-left: 5px;
}
.usersList {
  max-height: 480px;
  overflow-y: auto;
}
.margin-top-3Point5Perc {
  margin-top:3.5%;
}
.font-size-12Px {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/notification/m365/SendMentora365Notify.vue